import { Box, useTheme } from "@mui/material"
import { NormalText } from "../../shared/styles"
import { Link } from "react-router-dom"

export const SuccessfullMessage = ({ amount = '', coin = '', network = '', destinationNetwork = '' }) => {
    const { palette } = useTheme()

    return (
        <Box display={"flex"} flexDirection={'column'} gap={'4px'} borderRadius={'8px'} padding={'16px'} backgroundColor={palette.grey[3]}>
            <NormalText color={palette.primary.main} fontWeight={'bold'} size={14}>
                Transaction created successfully
            </NormalText>
            {amount && coin && network && destinationNetwork &&
                <NormalText>
                    You will receive an estimation of {amount} {coin} from {network} to {destinationNetwork}.
                </NormalText>
            }
            <NormalText>
                You can track the status of your transaction in the <Link to={'/transactions'} style={{
                    color: palette.primary.main,
                    textDecoration: 'none',
                }}>transactions</Link> section.
            </NormalText>
            <NormalText>
                The transaction will be executed in a few minutes.
            </NormalText>
        </Box>
    )
}